import React from "react";
import moment from "moment";

import { Button, Popover, OverlayTrigger } from "react-bootstrap";
import TileTitle from "components/Tiles/oldTileTitle";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBullseye, faBan, faExclamationTriangle, faCog, faChartBar } from "@fortawesome/free-solid-svg-icons";

import LoadingIndicator from "components/LoadingIndicator/LoadingIndicator";
import WaterFall from "components/Waterfall/Waterfall";

import RunPlot from "containers/RunPlot/RunPlot";

import createRunIcon from "images/tileIcons/model.svg";

import {
  InfoItem,
  InfoIcon,
  Icon,
  getPrettyNumber,
  NumberDisplay,
  ErrorOverlay,
  DeleteButton
} from "components/Home/Utils/Utils";
import getStyles from "components/Home/Utils/getStyles";

import styles from "./style.module.css";

const runStyles = getStyles("run");

export default class RunTile extends React.PureComponent {
  handleDelete(event) {
    event.stopPropagation();
    const { handleDelete } = this.props;

    if (handleDelete) {
      return handleDelete();
    } else return;
  }

  handleCancel(event) {
    event.stopPropagation();
    const { handleCancel } = this.props;

    if (handleCancel) {
      return handleCancel();
    } else return;
  }

  render() {
    const { run, isCreate, isHighlight, onClick, onHover, isMini, isFrontier, modelGroup, handleDelete, handleCancel } =
      this.props;

    if (isCreate) {
      return <CreateRunTile onClick={onClick} />;
    }

    if (!run) {
      return <React.Fragment></React.Fragment>;
    }

    const hasError = run.status === "ERROR" || (run.errors && run.errors.length > 0);

    const isDone = run.status === "DONE" || run.status === "ERROR";

    const best = run.transformedModels && run.transformedModels[0] ? run.transformedModels[0] : undefined;

    const warnings = run.annotations && run.annotations.filter((a) => a.type === "warning");

    const label = run ? (run.name ? run.name : run.setup && run.setup.label ? run.setup.label : "") : "";
    const runId = run ? run.id : "";

    const isModelGroup = modelGroup !== undefined && modelGroup.id !== undefined;

    let triggerImg = <Icon src={createRunIcon} style={{ padding: "0px" }} />;
    let triggerText = "";

    const isContinuous = best && best.metrics && best.metrics.sum_over_predict;

    const bestImpact =
      best &&
      (best.maxIteration.displayImpact
        ? Math.round(best.maxIteration.displayImpact)
        : isContinuous
          ? Math.round(best.metrics.overImpact + best.metrics.underImpact)
          : Math.round(best.checkMax));

    const isContinuousModel = best && best.metrics && Object.keys(best.metrics).length > 0;
    const isQuickRun = run && run.runType === "Academic";

    if (!isDone && !hasError) {
      triggerText = <h3 className={runStyles.text}>{"Training Models..."}</h3>;
    }

    if (isDone && !hasError) {
      triggerText = (
        <h1 title={bestImpact} className={runStyles.text + " " + styles.impactLabel}>
          {!isNaN(bestImpact) ? getPrettyNumber(bestImpact) : ""}
        </h1>
      );
      triggerImg = <RunTileWaterfall model={best} run={run} isIcon />;
    }
    return (
      <div className={styles.tileWrapper + " " + (isMini ? styles.miniTileWrapper : "")}>
        <div
          className={
            (onClick && !hasError && isMini !== true ? styles.tile : styles.tileNoHover) +
            (isHighlight ? " " + styles.modelHighlight : "") +
            " " +
            (isMini ? styles.miniTile : "") +
            " " +
            (isMini && hasError ? styles.miniTileError : "")
          }
          onClick={() => {
            if (onClick && !hasError) {
              onHover && onHover(undefined);
              return onClick();
            } else return;
          }}
          onMouseEnter={onHover ? () => onHover(run.id) : () => {}}
          onMouseLeave={onHover ? () => onHover(undefined) : () => {}}
        >
          <div className={styles.tileActions} style={hasError || !isDone ? { opacity: 1 } : {}}>
            {isDone ? (
              handleDelete && isMini !== true ? (
                <DeleteButton type={"run"} clickHandler={(event) => this.handleDelete(event)} />
              ) : (
                ""
              )
            ) : handleCancel ? (
              <DeleteButton
                type={"run"}
                action={"cancel"}
                icon={faBan}
                clickHandler={(event) => this.handleCancel(event)}
              />
            ) : (
              ""
            )}
          </div>
          {hasError ? (
            <ErrorOverlay
              errors={run.errors}
              popClass={styles.popList}
              popRowClass={styles.popRowMulti}
              retryHandler={onClick}
            />
          ) : (
            ""
          )}
          <div
            className={styles.tileHeader + (isMini ? " " + styles.miniTileHeader : "")}
            // style={{ height: "125px" }}
          >
            {isMini !== true && (
              <TileTitle title={label} overlayText={label + " (" + runId + ")"} className={runStyles.text} />
            )}
            {isMini ? (
              isDone ? (
                <RunTileWaterfall model={best} run={run} />
              ) : (
                <LoadingIndicator color={"var(--model-text)"} style={{ height: "36px", margin: "0px auto" }} />
              )
            ) : (
              ""
            )}
            {!isMini ? (
              <div className={styles.tileHeaderContent + " " + runStyles.background}>
                {isFrontier ? (
                  <RunPlot id={run.id} plotType={"Capacity Comparison"} isMini />
                ) : (
                  <div className={styles.tileTriggerWrapper}>
                    <div className={styles.tileTriggerIcon}>{triggerImg}</div>
                    <div className={styles.tileTriggerText}>{triggerText}</div>
                  </div>
                )}
              </div>
            ) : (
              ""
            )}
          </div>
          <div
            className={styles.tileBody + " " + (isMini ? styles.miniTileBody : "")}
            style={isMini && isDone !== true ? { height: "40px" } : {}}
          >
            {isDone ? (
              <React.Fragment>
                {run.dataset && run.dataset.outcome && isMini !== true ? (
                  <InfoItem icon={<InfoIcon type="target" />} text={run.dataset.outcome} hideMobile />
                ) : (
                  ""
                )}
                {run.isContinuous !== undefined &&
                run.runType !== undefined &&
                isMini !== true &&
                isModelGroup !== true ? (
                  <InfoItem icon={<InfoIcon type="type" />} text={run.isContinuous ? "Continuous" : "Categorical"} />
                ) : (
                  ""
                )}
                {run.createdDate ? (
                  <InfoItem
                    icon={<InfoIcon type="calendar" />}
                    text={moment.utc(run.createdDate).local().fromNow()}
                    title={moment.utc(run.createdDate).local().format("MMMM Do YYYY, h:mm:ss a")}
                  />
                ) : (
                  ""
                )}
                {isModelGroup && (
                  <InfoItem
                    icon={
                      <div style={{ margin: "0px 6px 0px 1px" }}>
                        <FontAwesomeIcon icon={faChartBar} />
                      </div>
                    }
                    text={"Model Group " + (modelGroup && modelGroup.value ? "(" + modelGroup.value.length + ")" : "")}
                  />
                )}
                {warnings && warnings.length > 0 && isMini !== true ? (
                  <OverlayTrigger
                    placement="top"
                    trigger={["click"]}
                    rootClose
                    overlay={
                      <Popover
                        id="popover-positioned-top"
                        title={warnings.length + " Warning" + (warnings.length > 1 ? "s" : "")}
                      >
                        <div className={styles.popList}>
                          {warnings.map((field, index) => (
                            <div key={index + field.message} className={styles.popRowMulti}>
                              {field.message}
                            </div>
                          ))}
                        </div>
                      </Popover>
                    }
                  >
                    <div onClick={(e) => e.stopPropagation()}>
                      <InfoItem
                        icon={<InfoIcon type="warning" />}
                        iconClass={styles.warningColor}
                        text={warnings.length + " Warning" + (warnings.length > 1 ? "s" : "")}
                        isLink
                      />
                    </div>
                  </OverlayTrigger>
                ) : (
                  ""
                )}
              </React.Fragment>
            ) : isMini ? (
              <div className={styles.isCreatingWrapper + " " + styles.isCreatingLabel + " " + runStyles.text}>
                {"Training Models..."}
              </div>
            ) : (
              <div className={styles.isCreatingWrapper}>
                <div className={styles.isCreatingIndicator}>
                  <LoadingIndicator
                    color={"var(--model-text)"}
                    style={{
                      width: "34px",
                      height: "34px",
                      transform: "scale(0.40) translate(-45%, -30%)",
                      margin: "0px auto"
                    }}
                  />
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}

class RunTileWaterfall extends React.PureComponent {
  render() {
    const { model, run, isIcon } = this.props;

    if (!model || !run) {
      return <React.Fragment></React.Fragment>;
    }

    const isContinuous = model && model.metrics && model.metrics.sum_over_predict;

    const bestImpact =
      model &&
      (model.maxIteration.displayImpact
        ? Math.round(model.maxIteration.displayImpact)
        : isContinuous
          ? Math.round(model.metrics.overImpact + model.metrics.underImpact)
          : Math.round(model.checkMax));

    const isContinuousModel = model && model.metrics && Object.keys(model.metrics).length > 0;
    const isQuickRun = run && run.runType === "Academic";

    return (
      <div className={styles.runWaterfallWrapper + (isIcon ? " " + styles.runWaterfallIconWrapper : "")}>
        <div className={styles.runWaterfallContent + (isIcon ? " " + styles.runWaterfallIconContent : "")}>
          <div className={styles.runWaterfall + (isIcon ? " " + styles.runWaterfallIcon : "")}>
            <WaterFall
              bars={model.bars}
              hideTotal={isQuickRun && !isContinuousModel}
              totalLabel={isContinuousModel ? "Absolute Error" : (run && run.setup && run.setup.netImpactLabel) || ""}
            />
          </div>
          {!isIcon && (isContinuous || !isQuickRun) ? (
            <NumberDisplay number={bestImpact} colorClass={runStyles.text} isThin hideMobile />
          ) : (
            ""
          )}
        </div>
      </div>
    );
  }
}

export class CreateRunTile extends React.PureComponent {
  render() {
    const { onClick } = this.props;
    const text = "Models";
    return (
      <div className={styles.tileWrapper}>
        <div className={onClick ? styles.tile : styles.tileNoHover} onClick={onClick ? () => onClick() : () => {}}>
          <div className={styles.createTileImageWrapper}>
            <div className={styles.createTileIcon}>
              <img src={createRunIcon} alt={text} />
            </div>
          </div>
          <div className={styles.createTileBody}>
            <div className={styles.createTileHeader + " " + runStyles.text}>{text}</div>
          </div>
        </div>
      </div>
    );
  }
}
